import { mapMultiSelectDropDownField } from '@ninja/utilities';
import { useAppPlatformContextOptions } from '../../../../../../contexts/app';
import { useFacilityTypes } from '../../../../../app-init-data';
import { NetworkSearchFilterForm } from '../useNetworkListForm';

export const usePlanFacilityType = () => {
	const { translate } = useAppPlatformContextOptions();
	const { facilityTypes } = useFacilityTypes();

	const facilityTypesOfNetwork = (planFacilityTypes: number[]) =>
		facilityTypes?.filter((f) => planFacilityTypes.includes(f.id));

	const getFacilityTypeFromPlan = (planFacilityTypes: number[]) =>
		mapMultiSelectDropDownField<NetworkSearchFilterForm, { id: number; name: string }, 'id'>({
			field: 'facilityTypeIds',
			label: translate('quote-list:quote-benefits-modal.network-list-content.facility-type'),
			placeholder: translate('quote-list:quote-benefits-modal.network-list-content.placeholder-select'),
			options: facilityTypesOfNetwork(planFacilityTypes),
			valueKey: 'id',
			labelKey: 'name',
			cancelButtonText: translate('quote-list:quote-benefits-modal.network-list-content.cancel'),
			applyButtonText: translate('quote-list:quote-benefits-modal.network-list-content.apply'),
		});

	return { getFacilityTypeFromPlan };
};
